import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ImportOutlined, MoreOutlined, PlusOutlined, SaveOutlined, LogoutOutlined } from '@ant-design/icons';
import { Button, Dropdown, Input, Menu, Modal, Table, message, Radio, Select } from 'antd';
import { Api } from '../../lib/api';
import './styles.scss';
import { Prompt } from 'react-router-dom';
import RenameModal from '../components/RenameModal';

import DeleteWarningModal from '../settings/components/DeleteWarningModal';
import { LABELS } from '../settings/components/pageNameConstants';

const SELECTION__CABLE = 'SELECTION__CABLE';
const SELECTION__TEST_PLAN = 'SELECTION__TEST_PLAN';

export default class Labels extends Component {
    state = {
        id: null,
        reportBro: false,
        name: null,
        modalVisible: false,

        closeAfterSave: false,
        previewVisible: false,
        modalSelection: SELECTION__CABLE,
        modalSelectedTestPlan: null,
        testPlan: {},
        cable: null,
        fiber: null,
        isBlocking: false
    };

    generateData(cable, fiber, polarity) {
        let polarityExpected = '';
        let name = 'Default';

        if (polarity && polarity.mapping !== undefined) {
            polarityExpected = polarity.mapping.toString();

            name = polarity.name;
        }
        else {
            polarityExpected = Array.from({ length: cable * fiber }, (_, index) => index + 1).join(',');
        }
        let data = {
            DUT: {
                SN: '123-4566-88',
                Date: '2021-01-01 12:00:00',
                Status: 'PASS',
                Wav1: '1310',
                Wav2: '1490',
                Wav3: '1550',
                Wav4: '1625',
                Core_Size: 'single',
                Cable: cable
            },
            Custom_Fields: { Customer: 'Acme', Batch: '1', Operator: 'Chris', PN: '12345' },
            rl1_measurements: [],
            specifications: {
                ILA_Spec: 2,
                ILB_Spec: 3,
                ILTotal_Spec: 5,
                RLA_Spec: 60,
                RLB_Spec: 60,
                RLTotal_Spec: 2
            },
            Connectors: {
                EndA_Connector: 'Grade A (IEC 61755-1)',
                EndB_Connector: 'Grade B (IEC 61755-1)'
            },
            polarity_measurements: {
                Type: name,
                Status: 'PASS',
                Expected: polarityExpected,
                Detected: polarityExpected
            }
        };

        for (let i = 0; i < cable * fiber; i++) {
            let cell = {
                Header: {
                    Fiber: i + 1 + ''
                },
                RL: {
                    RLA_Wav1: Math.floor(Math.random() * 10 + 1),
                    RLA_Wav2: Math.floor(Math.random() * 10 + 1),
                    RLA_Wav3: Math.floor(Math.random() * 10 + 1),
                    RLA_Wav4: Math.floor(Math.random() * 10 + 1),
                    RLB_Wav1: Math.floor(Math.random() * 10 + 1),
                    RLB_Wav2: Math.floor(Math.random() * 10 + 1),
                    RLB_Wav3: Math.floor(Math.random() * 10 + 1),
                    RLB_Wav4: Math.floor(Math.random() * 10 + 1),
                    RLTotal_Wav1: Math.floor(Math.random() * 10 + 1),
                    RLTotal_Wav2: Math.floor(Math.random() * 10 + 1),
                    RLTotal_Wav3: Math.floor(Math.random() * 10 + 1),
                    RLTotal_Wav4: Math.floor(Math.random() * 10 + 1)
                },
                IL: {
                    ILA_Wav1: Math.floor(Math.random() * 10 + 1),
                    ILA_Wav2: Math.floor(Math.random() * 10 + 1),
                    ILA_Wav3: Math.floor(Math.random() * 10 + 1),
                    ILA_Wav4: Math.floor(Math.random() * 10 + 1),
                    ILB_Wav1: Math.floor(Math.random() * 10 + 1),
                    ILB_Wav2: Math.floor(Math.random() * 10 + 1),
                    ILB_Wav3: Math.floor(Math.random() * 10 + 1),
                    ILB_Wav4: Math.floor(Math.random() * 10 + 1),
                    ILTotal_Wav1: Math.floor(Math.random() * 10 + 1),
                    ILTotal_Wav2: Math.floor(Math.random() * 10 + 1),
                    ILTotal_Wav3: Math.floor(Math.random() * 10 + 1),
                    ILTotal_Wav4: Math.floor(Math.random() * 10 + 1)
                },
                RLTotal_DualMtj: {
                    RLTotal_Wav1: Math.floor(Math.random() * 10 + 1),
                    RLTotal_Wav2: Math.floor(Math.random() * 10 + 1),
                    RLTotal_Wav3: Math.floor(Math.random() * 10 + 1),
                    RLTotal_Wav4: Math.floor(Math.random() * 10 + 1)
                },

                RLTotal_SingleMtj: {
                    RLTotal_EndA_Wav1: Math.floor(Math.random() * 10 + 1),
                    RLTotal_EndA_Wav2: Math.floor(Math.random() * 10 + 1),
                    RLTotal_EndA_Wav3: Math.floor(Math.random() * 10 + 1),
                    RLTotal_EndA_Wav4: Math.floor(Math.random() * 10 + 1),
                    RLTotal_EndB_Wav1: Math.floor(Math.random() * 10 + 1),
                    RLTotal_EndB_Wav2: Math.floor(Math.random() * 10 + 1),
                    RLTotal_EndB_Wav3: Math.floor(Math.random() * 10 + 1),
                    RLTotal_EndB_Wav4: Math.floor(Math.random() * 10 + 1)
                }
            };
            data.rl1_measurements.push(cell);
        }
        return data;
    }
    leaveF(location) {
        let reportBro = document.getElementById('reportbro-frame').contentWindow.window.reportBroInstance;
        let isModified = reportBro.modified;
        if (!isModified) {
            // No changes to document.
            // Leave Report Bro.
            this.setState({ reportBro: false });
            return;
        }

        return `Are you sure you want to go to ${location.pathname}?  \n Your unsaved label could be lost if you leave this page  `;
    }

    getTestPlans() {
        Api.getTestPlans().then((testPlans) => {
            this.setState({ testPlans: testPlans });
        });
    }
    saveLabel() {
        document.getElementById('reportbro-frame').contentWindow.labelSaved = (success) => {
            if (success) {
                // Successfully saved
                message.success(`Label ${this.state.name} saved`, 1);

                // If this was done from the Save/Discard modal, close the modal and close ReportBro
                if (this.state.closeAfterSave) {
                    this.setState({
                        modalVisible: false,
                        reportBro: false
                    });
                }
            } else {
                message.error('Failed to save label', 3);
            }

            // Reset 'closeAfterSave' regardless of the save outcome
            this.setState({
                closeAfterSave: false
            });
        };
    }
    render() {
        if (this.state.reportBro) {
            return (
                <React.Fragment>
                    <div className="frame_2">
                        <iframe
                            id="reportbro-frame"
                            title="Create Label"
                            onLoad={() => this.saveLabel()}
                            src={
                                'reportbro/reportbro.html?type=label' +
                                (this.state.id === null ? '' : '&id=' + this.state.id) +
                                (this.state.id === null && this.state.name !== null ? '&name=' + this.state.name : '')
                            }
                            className="frame"
                        ></iframe>
                        <div id="labels-page">
                            <Prompt when={true} message={(location) => this.leaveF(location)} />
                            <Modal
                                open={this.state.modalVisible}
                                title="Unsaved Changes"
                                onCancel={() => this.setState({ modalVisible: false })}
                                closable={false}
                                destroyOnClose={true}
                                footer={[
                                    <Button
                                        key="save"
                                        type="primary"
                                        onClick={() => {
                                            let reportBro = document.getElementById('reportbro-frame').contentWindow.window.reportBroInstance;
                                            this.setState({ closeAfterSave: true });
                                            reportBro.save();
                                            message.success(`Label ${this.state.name} saved`, 1);
                                        }}
                                    >
                                        Save
                                    </Button>,
                                    <Button
                                        key="discard"
                                        type="danger"
                                        onClick={() => this.setState({ modalVisible: false, reportBro: false })}
                                    >
                                        Discard
                                    </Button>,
                                    <Button key="cancel" onClick={() => this.setState({ modalVisible: false })}>
                                        Cancel
                                    </Button>
                                ]}
                            >
                                Some changes have not been saved.
                            </Modal>
                            <div className="label-name">{this.state.name}</div>
                            <div className="f-div">
                                <Button
                                    type="primary"
                                    shape="round"
                                    icon={<SaveOutlined />}
                                    onClick={() => {
                                        let reportBro = document.getElementById('reportbro-frame').contentWindow.window.reportBroInstance;
                                        this.setState({ closeAfterSave: true });
                                        reportBro.save();
                                    }}
                                    className="small"
                                >
                                    Save Label
                                </Button>
                                &nbsp; &nbsp;
                                <Button
                                    shape="round"
                                    onClick={() => {
                                        this.getTestPlans();
                                        this.setState({ previewVisible: true });
                                    }}
                                    className="small"
                                >
                                    Preview with Data
                                </Button>
                                &nbsp; &nbsp;
                                <Button
                                    onClick={() => {
                                        window.open('https://www.reportbro.com/doc/userguide', '_blank');
                                    }}
                                    type="dashed"
                                    shape="round"
                                    className="small-tutorial"
                                >
                                    Tutorial
                                </Button>
                                <Button
                                    onClick={() => {
                                        let reportBro = document.getElementById('reportbro-frame').contentWindow.window.reportBroInstance;

                                        // Get the modified status of the ReportBro document
                                        //
                                        // This is a hack since ReportBro doesn't provide direct access to the modified status.
                                        let isModified = reportBro.modified;

                                        if (!isModified) {
                                            // No changes to document.
                                            // Leave Report Bro.
                                            this.setState({ reportBro: false });

                                            return;
                                        }

                                        // Unsaved changes. Show the Save/Discard modal
                                        this.setState({ modalVisible: true });
                                    }}
                                    type="danger"
                                    shape="round"
                                    icon={<LogoutOutlined />}
                                    className="small"
                                >
                                    Exit
                                </Button>
                            </div>
                            <Modal
                                title={<div className="title">Preview Label</div>}
                                open={this.state.previewVisible}
                                width={500}
                                onOk={() => this.setState({ previewVisible: false })}
                                onCancel={() => this.setState({ previewVisible: false })}
                                footer={
                                    <div className="footer">
                                        <div className="buttons">
                                            <Button
                                                type="primary"
                                                onClick={() => {
                                                    let reportBro = document.getElementById('reportbro-frame').contentWindow.window.reportBroInstance;
                                                    let labelData = this.generateData(this.state.cable, this.state.fiber, this.state.polarity);

                                                    reportBro.previewWithData(labelData);
                                                    this.setState({ previewVisible: false, fiber: null, cable: null });
                                                }}
                                            >
                                                Preview
                                            </Button>
                                            <Button
                                                onClick={() => {
                                                    this.setState({ previewVisible: false });
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                        </div>
                                    </div>
                                }
                                closable={false}
                                destroyOnClose={true}
                            >
                                <Radio.Group
                                    buttonStyle="solid"
                                    defaultValue={this.state.modalSelection}
                                    onChange={(e) => {
                                        this.setState({ modalSelection: e.target.value });
                                    }}
                                >
                                    <Radio.Button value={SELECTION__CABLE}>Fiber</Radio.Button>
                                    <Radio.Button value={SELECTION__TEST_PLAN}>Test Plan</Radio.Button>
                                </Radio.Group>
                                {
                                    // cable section
                                    this.state.modalSelection === SELECTION__CABLE && (
                                        <React.Fragment>
                                            <div>Cable: </div>
                                            <Input
                                                defaultValue={this.state.cable}
                                                onChange={(e) => this.setState({ cable: e.target.value })}
                                            />
                                            <div>Fiber: </div>
                                            <Input
                                                defaultValue={this.state.fiber}
                                                onChange={(e) => this.setState({ fiber: e.target.value })}
                                            />
                                        </React.Fragment>
                                    )
                                }
                                {
                                    // test plan section
                                    this.state.modalSelection === SELECTION__TEST_PLAN && (
                                        <React.Fragment>
                                            <div>Select Test Plan:</div>
                                            <Select
                                                defaultValue={this.state.modalSelectedTestPlan}
                                                onChange={(testPlanId) => {
                                                    if (testPlanId) {
                                                        var result = this.state.testPlans.filter((obj) => {
                                                            return obj.id === testPlanId;
                                                        });

                                                        this.setState({
                                                            fiber: result[0].wizardData.fibersPerCable,
                                                            cable: result[0].wizardData.cablesPerAssembly,
                                                            polarity: result[0].wizardData.assembly.polarity
                                                        });
                                                    }
                                                }}
                                                style={{ width: '180px' }}
                                            >
                                                {Object.values(this.state.testPlans).map((testPlan) => (
                                                    <Select.Option key={testPlan.id} value={testPlan.id}>
                                                        {testPlan.name}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </React.Fragment>
                                    )
                                }
                            </Modal>
                        </div>
                    </div>
                </React.Fragment>
            );
        }

        return (
            <div id="labels-page">
                <LabelList updateReportBro={(id, name, show) => this.setState({ id: id, name: name, reportBro: show })} />
            </div>
        );
    }
}

class LabelList extends Component {
    static propTypes = {
        updateReportBro: PropTypes.func
    };

    state = {
        labels: [],
        renameName: {},
        focusedInput: null,
        createVisible: false,
        createLabelName: null,
        showDeleteModal: false,
        showRenameModal: false
    };

    componentDidMount() {
        this.getLabels();
    }

    getLabels = async () => {
        await Api.getLabels().then((labels) => {
            let labels_1 = labels;

            if (labels_1[labels_1.length - 1].name === 'DEFAULT_BARCODE_LABEL') {
                labels_1.pop();
            }
            this.setState({ labels: labels_1 });
        });
    }

    deleteLabel = (id) => {
        return Api.deleteLabel(id);
    }

    import() {
        let input = document.createElement('input');
        input.type = 'file';
        input.setAttribute('multiple', '');

        input.addEventListener('change', () => {
            for (let i = 0; i < input.files.length; i++) {
                this.importFile(input.files[i]);
            }
        });

        input.click();
    }

    importFile(file) {
        let reader = new FileReader();
        reader.onload = (text) => {
            try {
                let label = JSON.parse(text.target.result);

                Api.createLabel({
                    name: label.name,
                    reportSpec: label.reportSpec
                }).then(() => this.getLabels());
            } catch (e) {
                console.error(e);
                // Skip
            }
        };

        reader.readAsText(file);
    }

    export(id) {
        Api.getLabel(id).then((label) => {
            let link = document.createElement('a');
            let name = label.name.replace(/[^\w -]/g, ' ').trim();
            link.download = name.length > 0 ? name + '.txt' : 'label.txt';
            let json = JSON.stringify(label);
            link.href = 'data:,' + encodeURIComponent(json);
            link.click();
        });
    }

    async duplicate(id) {
        let label = await Api.getLabel(id);
        let newName = label.name + ' Copy';
        if(!this.nameAlreadyExists(newName)) {
            await Api.createLabel({
                name: newName,
                reportSpec: label.reportSpec
            });
            this.getLabels();
        }
    }

    nameAlreadyExists = (name) => {
        if(this.state.labels.some(label => name === label.name)) {
            alert(`Label name: '${name}' already in use.`);
            return true;
        }
        return false;
    }

    rename = async (id, newName) => {
        try {
            if(!this.nameAlreadyExists(newName)) {
                await Api.updateLabel(id, {name: newName});
            }
        } catch (e) {
            console.error('Failed to update label');
        }
    }

    createLabel() {
        if(!this.nameAlreadyExists(this.state.createLabelName)) {
            this.props.updateReportBro(null, this.state.createLabelName, true);
        }
    }

    closeDeleteModal = () => {
        this.setState({showDeleteModal: false});
    }

    closeRenameModal = () => {
        this.setState({showRenameModal: false});
    }

    render() {
        return (
            <React.Fragment>
                <RenameModal
                    isOpen={this.state.showRenameModal}
                    uuid={this.state.focusedInput}
                    name={this.state.renameName}
                    closeCallback={this.closeRenameModal}
                    refreshCallback={this.getLabels}
                    rename={this.rename}
                    type={'label'}
                ></RenameModal>
                <Modal
                    open={this.state.createVisible}
                    title="Label Name"
                    onCancel={() => this.setState({ createVisible: false })}
                    closable={false}
                    destroyOnClose={true}
                    footer={[
                        <Button key="submit" type="primary" onClick={() => this.createLabel()}>
                            Create
                        </Button>,
                        <Button key="back" onClick={() => this.setState({ createVisible: false })}>
                            Cancel
                        </Button>
                    ]}
                >
                    <Input
                        ref={(element) => element && element.focus()}
                        onChange={(e) => this.setState({ createLabelName: e.target.value })}
                        onKeyUp={(e) => {
                            if (e.keyCode === 13) {
                                this.createLabel();
                            } else if (e.keyCode === 27) {
                                this.props.setVisible(false);
                            }
                        }}
                    />
                </Modal>
                <div className="page-card">
                    <div className="create-button">
                        <Button
                            className="tconnector-btn"
                            shape="round"
                            icon={<ImportOutlined />}
                            onClick={() => this.import()}
                        >
                            Import Label
                        </Button>
                        <Button
                            type="primary"
                            shape="round"
                            icon={<PlusOutlined />}
                            onClick={() => this.setState({ createVisible: true })}
                        >
                            New Label
                        </Button>
                    </div>

                    <Table
                        className="label-list"
                        columns={[
                            {
                                title: 'Label',
                                dataIndex: 'name',
                            },

                            {
                                title: 'Modified On',
                                align: 'center',
                                sortDirections: ['ascend', 'descend'],
                                render: (text, record) => <React.Fragment>{record.updatedAt.slice(0, 10)}</React.Fragment>
                            },
                            {
                                title: <div style={{ display: 'flex' }}></div>,
                                align: 'center',
                                width: '50px',
                                render: (text, record) => (
                                    <Dropdown
                                        overlay={
                                            <Menu>
                                                <Menu.Item
                                                    onClick={() => this.props.updateReportBro(record.id, record.name, true)}
                                                >
                                                    Edit
                                                </Menu.Item>
                                                <Menu.Item
                                                    onClick={() =>
                                                        this.setState(({
                                                            renameName: record.name,
                                                            focusedInput: record.id,
                                                            showRenameModal: true
                                                        }))
                                                    }
                                                >
                                                    Rename
                                                </Menu.Item>
                                                <Menu.Item onClick={() => this.duplicate(record.id)}>Duplicate</Menu.Item>
                                                <Menu.Item onClick={() => this.export(record.id)}>Export</Menu.Item>
                                                <Menu.Divider />
                                                <Menu.Item onClick={() => this.setState({
                                                    showDeleteModal: true,
                                                    labelName: record.name,
                                                    labelRecord: record.id
                                                    })
                                                }>Delete</Menu.Item>
                                            </Menu>
                                        }
                                        trigger={['click']}
                                    >
                                        <div className="menu-label">
                                            <MoreOutlined />
                                        </div>
                                    </Dropdown>
                                )
                            }
                        ]}
                        dataSource={this.state.labels}
                        rowKey="id"
                        pagination={{ pageSize: 8 }}
                    />
                    <DeleteWarningModal
                        isOpen={this.state.showDeleteModal}
                        itemTypeToDelete={LABELS}
                        itemNameToDelete={this.state.labelName}
                        itemRecordToDelete={this.state.labelRecord}
                        closeCallback={this.closeDeleteModal}
                        update={this.getLabels}
                        delete={this.deleteLabel}
                    >
                    </DeleteWarningModal>
                </div>
            </React.Fragment>
        );
    }
}
